import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
import {
  ChartData,
  ChartJsType,
  ChartOptions,
} from '../../models/chart.models';
import { DEFAULT_CHART_OPTIONS } from '../../constants/common.constants';
import { Chart, registerables } from 'chart.js';
import AnnotationPlugin from 'chartjs-plugin-annotation';
import ZoomPlugin from 'chartjs-plugin-zoom';

Chart.register(...registerables, AnnotationPlugin, ZoomPlugin);

@Component({
  selector: 'chart-base',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <div class="block relative" [style.height.px]="height()">
      <canvas #chartCanvas [height]="height()"></canvas>
    </div>
  `,
})
export class ChartBase {
  canvasElement =
    viewChild.required<ElementRef<HTMLCanvasElement>>('chartCanvas');

  type = input.required<ChartJsType>();
  data = input.required<ChartData<ChartJsType>>();
  options = input<ChartOptions>(DEFAULT_CHART_OPTIONS);
  plugins = input<any[]>([]);
  width = input<number>();
  height = input<number>();

  public chartInstance!: Chart;

  effect1 = effect(() => {
    const data = this.data();
    const options = this.options();

    if (this.chartInstance) {
      this.chartInstance.data = data;
      this.chartInstance.options = options;
      this.chartInstance.update();
    }
  });

  ngAfterViewInit(): void {
    this.initializeChart();
  }

  private initializeChart(): void {
    this.chartInstance = new Chart(this.canvasElement().nativeElement, {
      type: this.type(),
      data: this.data(),
      options: this.options(),
      plugins: this.plugins(),
    });
    this.chartInstance.update();
  }
}
